import CurrencyAmount from '@components/currency-amount/CurrencyAmount';

const AttendanceSessionDetails = ({
  costPerSession,
  noOfSessions
}: {
  costPerSession?: string | number;
  noOfSessions?: string | number;
}) => (
  <div className="mb-6 flex flex-col items-center justify-center rounded-xl border border-cofeeGreyBlue5 p-4">
    <div className="flex w-full items-center justify-between border-b border-cofeeGreyBlue5 pb-2 text-sm">
      <span className=" text-grey">Rate per class</span>
      <CurrencyAmount value={Number(costPerSession)} className="text-base" />
    </div>
    <div className="flex w-full items-center justify-between pt-2">
      <span className="text-sm text-grey">Number of classes</span>
      <span className="text-base text-cofeeNeutral10">{noOfSessions}</span>
    </div>
  </div>
);

export default AttendanceSessionDetails;
